export default __webpack_public_path__ + "static/media/48.71f8c8f5.jpg";